<label #dropdown (click)="openDropdown()">
  @if (field.label) {
    <fmnts-label
      class="form-field__label form-field__text-label"
      [class.form-field__label--error]="showError"
    >
      {{ field.label | translateInline }}
    </fmnts-label>
  }

  <input
    #element
    [(ngModel)]="value"
    placeholder="{{ 'field_placeholder_address_search' | translate }}"
    class="form-field__input form-field__text-input"
    [class.form-field__input--error]="showError"
    (blur)="_onTouched()"
    (keyup)="openDropdown()"
    (focus)="_onFocus()"
    [attr.autocapitalize]="autocapitalize"
    [attr.autocomplete]="autocomplete()"
  />
  @switch (provider) {
    @case ('loqate') {
      <div class="form-field__select-dropdown-wrapper">
        <ul
          class="form-field__select-dropdown"
          [class.form-field__select-dropdown--focused]="dropdownShown$ | async"
        >
          @if (canImproveSearchAccuracy()) {
            <div class="form-field__address-search-accuracy-hint">
              {{ 'field_address_search_accuracy_hint' | translate }}
            </div>
          }

          @for (item of results$ | async; track item.Id) {
            <li
              class="form-field__select-dropdown-item form-field__select-dropdown-item--selectable"
              [class.hidden]="vm.state() !== 'loaded'"
            >
              <div (click)="selectedSearchResult$.next(item)">
                <b>{{ item.Text }}</b> {{ item.Description }}
              </div>
            </li>
          }

          @if (vm.state() === 'loading') {
            <fmnts-loading-indicator
              variant="fontawesome"
              class="form-field__address-search-loading"
              size="sm"
            ></fmnts-loading-indicator>
          }
        </ul>
      </div>
    }
  }

  <div class="form-field__error-message">
    @if (showError && control.errors) {
      <fmnts-form-error>
        {{ control.errors | declarativeErrorMessage: field : declaration }}
      </fmnts-form-error>
    }
  </div>
</label>
